import { Component, OnInit, ViewChild } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompaniesService } from '../../../services/companies.service';
import {ConsultantService} from '../../../services/consultant.service';
import { OwnerService } from '../../../services/billing-letter/owner.service';
import { ProductService } from '../../../services/product.service';
import { Owner } from '../../../models/billing-letter/Owner.model';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl  } from '@angular/forms';
import { ToastsManager } from "ng2-toastr";
import { HashtrackService } from "../../../services/hashTrack.service";
import { AwsService } from '../../../services/aws.service';
import { BankService } from '../../../services/bank.service';
import { DropDownList } from '../../../models/DropDownList.model';
import { ExternalReferenceFinancial } from '../../../models/ExternalReference.model';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { GUARDS } from '../../../shared/auth/Roles';
import * as moment from 'moment';
import * as _ from 'lodash';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType';
import { PaymentType } from '../../../shared/enums/PaymentType';
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ProjectFinancial } from '../../../models/project/ProjectFinancial.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Industry } from '../../../models/Industry.model';
import { IndustriesService } from '../../../services/industries.service';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { CnaeService } from '../../../services/cnae.service';

@Component({
  selector: 'app-companies-edit',
  templateUrl: './companies-edit.component.html',
  styleUrls: ['./companies-edit.component.css']
})
export class CompaniesEditComponent implements OnInit {
  @ViewChild("projectsMultiselect") projectsMultiselect;

  hashCustomers;
  emails: string[];
  name: string;
  companyForm: FormGroup;
  company: Company = new Company();
  companies: Company = new Company();
  projects: ProjectFinancial[] = new Array<ProjectFinancial>();
  project: ProjectFinancial = new ProjectFinancial();
  commonHelper: CommonHelper = new CommonHelper();

  dropDownProjects = {
    dropDownList: new Array<DropDownList>(),
    selectedItems: new Array<DropDownList>(),
    dropDownSettings: {},
    commonHelper: new CommonHelper(),
  };

  marginList = []
  minValue = 0
  datePickerOptions = this.commonHelper.getDatePickerOptions();
  cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
  mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
  agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
  digitMask = [/[A-Za-z0-9]/];
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companyGroupSearchModel: CompanyGroupSearch;
  loading: boolean;
  DropDownHash: DropDownList[] = new Array<DropDownList>();
  DropDownSettings = {};
  selectedHash: DropDownList[] = new Array<DropDownList>();
  industries: Industry[] = new Array<Industry>();
  managers: Owner[] = [];
  fileList;
  selectedFiles:FileList;
  downloadUrl:string = '';
  pixKeyVerifyMethod : any;
  pixKeyFlag: Boolean = true;
  pixCpfValid : Boolean;
  pixCnpjValid : Boolean;
  phoneMaskFlag: Boolean = false;
  textMask;
  user;
  hidePrivateData: Boolean = false;
  banks : any = [];
  GUARDS = GUARDS;
  canSave: Boolean = true;
  dateProblem: boolean = false;
  allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.JUDICIARY, GUARDS.DP, GUARDS.BILLSRECEIVE];

  items = [];
  itemsDropdown = {
    list: [],
    options: null,
    selected: []
  };

  datePickerYear;
  validateMargins = {
    value: 0,
    percentage: 0,
    startDate: "",
    endDate: "",
  }

  constructor(private companiesService: CompaniesService,
    private consultantService: ConsultantService,
    private productService: ProductService,
    private ownerService: OwnerService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private tostr: ToastsManager,
    private awsService:AwsService,
    private hashtrackService: HashtrackService,
    private industriesService: IndustriesService,
    private dropDownItemFactory: DropdownItemFactory,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private projectsFinancialService: ProjectFinancialService,
    public toastr: ToastsManager,
    private localStorage: LocalStorage,
    private bankService: BankService,
    public pixValidation: PixValidation,
    private cnaeService: CnaeService) { }

  async ngOnInit() {
    this.loading = true;

    this.checkPermissions();

    this.companyForm = this.formBuilder.group({
      name: [null, Validators.required],
      companyName: [null, Validators.required],
      companyGroup: [null, [this.validateSelectOption]],
      industry: [null, [this.validateSelectOption]],
      ownerName: [null, [this.validateSelectOption]],
      manager: [null, [this.validateSelectOption]],
      cnpj: [null, [Validators.required, Validators.pattern(this.cnpjPattern)]],
      emails: [null, Validators.required],
      keyPix:[null, [this.validateKeyPix]],
    });

    const company = await this.companiesService.getById(this.route.snapshot.params["id"]);

    this.company = company;

    this.industries = await this.industriesService.getAll();
    this.hashCustomers = await this.hashtrackService.getAllCustomers();
    this.DropDownHash = this.commonHelper.getDropDownListItems(this.hashCustomers, "_id", "name");
    this.DropDownSettings = this.commonHelper.getDropDownSettings(true, "Cliente", false, "", "", true,null, "");
    this.managers = await this.ownerService.getAll();
    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.banks = await this.bankService.getBanks();

    let response = await this.projectsFinancialService.getProjectsAndCustomers();
    this.projects = response.projects;
    this.populateProjects()
    this.dropDownProjects.dropDownSettings = this.commonHelper.getDropDownSettings(true, "Projetos", true, "", "", true, null, "");
    this.company.isOmnikIntegration;

    if(this.company.start)
      this.company.start = moment(this.company.start).format("DDMMYYYY");
    if(this.company.end)
      this.company.end = moment(this.company.end).format("DDMMYYYY");

    if (this.company.externalReference) {
      let companyHT = this.DropDownHash.find(x => x.id == this.company.externalReference._id);
      if (companyHT) {
        let ddl = new DropDownList();
        ddl.id = company.externalReference._id;
        ddl.itemName = companyHT.itemName;
        this.selectedHash.push(ddl);
      }
    } else
      this.selectedHash = null;

      if (this.company.billingProject) {
        let projects = this.dropDownProjects.dropDownList.find(x => x.id == this.company.billingProject._id);
        if (projects) {
          let pjCompany = new DropDownList();
          pjCompany.id = company.billingProject._id;
          pjCompany.itemName = projects.itemName;
          this.dropDownProjects.selectedItems.push(pjCompany);
        }
      } else
        this.dropDownProjects.selectedItems = null;

    await this.getS3Files();
    if(this.fileList.length > 0){
      this.download(this.fileList[0].Key);
    }

    if(!this.company.isCustomer) {
        this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
        this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);
        this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:false,enableCheckAll:false});
        this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});
        this.company.defaultItems.forEach(item => {
            const itemDropDown = this.itemsDropdown.list.find(i => i.sapItemCode === item);
            if(itemDropDown) this.itemsDropdown.selected.push(itemDropDown);
        });
    }

    if(this.pixKeyFlag){
        this.pixKeyFlag = false;
    }

    if(!this.company.payment.typePix) {
        this.company.payment.typePix = 0
        this.companyForm.get("keyPix").disable();
    }

    if(this.company.payment.keyPix){
        this.textMask = {mask: false}
    }

    this.company = this.checkOwnerAndManager(this.company);

    if(this.company && this.company.isCustomer) {
        this.companyForm.get("companyGroup").enable();
        this.companyForm.get("industry").enable();
    } else {
        this.companyForm.get("companyGroup").disable();
        this.companyForm.get("industry").disable();
    }

    if (this.user.permission == GUARDS.RS) {
        this.hidePrivateData = true ;
    }

    this.loading = false;
  }

  populateProjects(): void {
    this.projects = this.projects.filter(x => x.companyId == this.company._id);
    this.dropDownProjects = this.projectsFinancialService.createPropertyObjDropDown(this.projects, true, "Projetos", "projetos");
  }

  addMargin() {
    this.company.margins.push({value: 0, percentage: 0})
  }

  removeContact(index) {
    this.company.margins.splice(index, 1);
  }

  onDatePickerChange(date , field: string) {

    let dateFields =  new Date(date);
    if((field === 'start' &&  dateFields < new Date(this.company.contractEnd)) || !this.company.contractEnd ){
      this.company.contractStart = date
      this.dateProblem = false;
      return
    }

    if((field === 'end'  && dateFields > new Date(this.company.contractStart))  || !this.company.contractStart   ) {
      this.company.contractEnd = date
      this.dateProblem = false;
      return
    }

    this.toastr.warning('A data final deve ser maior que a data de início');
    this.dateProblem = true;

  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
    }
  }

  async OnSave() {
    try{
        if(!this.company.payment.keyPix && this.company.payment.typePix != 0){
            this.tostr.warning("A chave pix é obrigatória")
            return;
        }

        if (this.companyForm.valid) {
            if(this.company.companyName.length > 100)
                return this.tostr.warning('O nome da empresa é longo demais, permitido apenas 100 caracteres!');

            this.company.manager.name = this.managers.find(x => x._id === this.company.manager._id).name;
            this.company.owner.name = this.managers.find(x => x._id === this.company.owner._id).name;

            if(this.company.isOmnikIntegration){
              if(this.dropDownProjects.selectedItems.length > 0){
                this.company.billingProject.name = this.dropDownProjects.selectedItems[0].itemName
                this.company.billingProject._id = this.dropDownProjects.selectedItems[0].id
              } else {
                this.company.billingProject = null;
                  return this.tostr.warning('Selecione um projeto para realizar a integração!');
              }

              if(!this.company.tenantId)
                return this.tostr.warning('Adicione um Tenant ID para realizar a integração!');

              if(!this.company.minValue)
                return this.tostr.warning('Adicione um valor minimo para realizar a integração!');

              if(!this.company.billingType){
                  this.company.omnikIntegrationYear = this.datePickerYear
              }

              if(this.company.billingType == 'annual' && (!this.company.contractStart || !this.company.contractEnd)){
                return this.tostr.warning('Adicione um valor de Data inicial e final, para realizar a integração!');
              }

              if(!this.company.margins.length){
                return this.tostr.warning('Adicione pelo menos uma margem para realizar a integração!');
              }

              for (let i = 0; i < this.company.margins.length; i++) {
                const margin = this.company.margins[i];

                // negando a condição para evitar problemas com NaN e undefined que sempre retornam falso
                if (!(margin.value > 0)) {
                    return this.tostr.warning('Adicione um valor no campo "Acima de R$" na margem, para realizar a integração!');
                }

                if (!(margin.percentage > 0)) {
                    return this.tostr.warning('Adicione um valor de porcentagem na margem, para realizar a integração!');
                }
              }
            }

            if (this.selectedHash && this.selectedHash.length > 0) {
                this.company.externalReference = new ExternalReferenceFinancial();
                this.company.externalReference._id = this.selectedHash[0].id;
                this.company.externalReference.name = this.selectedHash[0].itemName;
            } else
                this.company.externalReference = null;

            if(this.company.industry)
                this.company.industry = this.industries.find(x => x._id === this.company.industry._id);

            if(this.company.companyGroup._id != '' && this.company.companyGroup._id != undefined)
                this.company.companyGroup.name = this.companyGroups.find(x => x._id === this.company.companyGroup._id).name;

            if(!this.company.isCustomer && this.itemsDropdown.selected.length > 0){
                const itemsSelected = this.itemsDropdown.selected.map(item => {
                    return item.sapItemCode;
                });
                this.company.defaultItems = itemsSelected;
            }

            this.loading = true;
            let response = await this.companiesService.edit(this.company);
            if(response._id){
                this.loading = false;
                this.tostr.success('Empresa atualizada com sucesso!');
                this.router.navigate(['/companies']);
            } else {
                this.loading = false;
                this.tostr.warning("Erro ao atualizar empresa");
            }
        }

    } catch(err){
        this.loading = false;
        console.log(err)
        this.tostr.warning("Erro ao atualizar empresa");
    }
  }

  verifyValidTouched(fieldName) {
    return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
  }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == 'undefined' || control.value == undefined)
            return {valid: true};
        return null;
    }

    trim(){
        if(this.company.payment.keyPix)
            this.company.payment.keyPix = this.company.payment.keyPix.trim();
    }

    checkOwnerAndManager(company: Company): Company {
        const fields = ['owner', 'manager'];
        let newCompanyData = {...company};
        fields.forEach((field) => {
            if (newCompanyData[field] && newCompanyData[field]._id) {
                newCompanyData[field] = this.managers.find(item => item._id == newCompanyData[field]._id);
            }
            else newCompanyData[field] = null;
        })
        return newCompanyData as Company;
    };

    async verifyCNPJ(){
        if(this.company.cnpj == '' || this.company.cnpj == undefined) {
            this.tostr.warning('CNPJ não pode ser vazio');
        } else {
            let response = await this.companiesService.verifyCnpj(this.company);
            if(response.length > 0){
                this.tostr.warning(`O CNPJ está cadastrado para o cliente ${response[0].name?response[0].name:""}`,'CNPJ em uso!',);
                this.company.cnpj = '';
            } else {
                await this.cnpjSearch();
            }
        }
    }

    async cnpjSearch(){
        if(this.company.cnpj == '' || this.company.cnpj == undefined) {
            this.tostr.warning('CNPJ não pode ser vazio');
        } else if (!this.companiesService.cnpjValid(this.company.cnpj)) {
            this.tostr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');
        } else {
            this.tostr.warning('Realizando consulta ao CNPJ...');
            let response = await this.companiesService.getCnpj(this.company.cnpj);
            if(response.status == 'ERROR'){
                this.tostr.warning(response.message);
            } else {
                if(response.fantasia != '') this.company.name = response.fantasia;
                if(response.nome != '') this.company.companyName = response.nome;
                if(response.logradouro != '') this.company.address.street = response.logradouro;
                if(response.numero != '') this.company.address.number = response.numero;
                if(response.complemento != '') this.company.address.complement = response.complemento;
                if(response.municipio != '') this.company.address.city = response.municipio;
                if(response.uf != '') this.company.address.uf = response.uf;
                if(response.bairro != '') this.company.address.district = response.bairro;
                if(response.cep != '') this.company.address.zipCode = response.cep;
                if(response.tipo != '') this.company.address.type = response.tipo;
            }
        }
    }

    async verifyCPFCNPJPixKey(){
        if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
            this.tostr.warning("O CPF/CNPJ é obrigatório!");
            this.company.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.company.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.company.payment.keyPix)){
          this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
          this.tostr.warning('CPF/CNPJ inválido.');
          this.company.payment.keyPix = "";
        }
      }

    cnpjValid(cnpj: String) {
        return this.companiesService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.companiesService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(this.company.payment.keyPix == '' || this.company.payment.keyPix == undefined) {
            this.tostr.warning('Aleatório não pode ser vazio');
        } else if (!this.consultantService.randomPixKeyValid(this.company.payment.keyPix)) {
            this.tostr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
            this.company.payment.keyPix = ''
        }
    }

    async verifyEmailPixKey(){
        this.trim();

        if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
         this.tostr.warning("O Email é obrigatório!");
         this.company.payment.keyPix = "";
        }else{
          if (!(new RegExp(this.emailPattern).test((this.company.payment.keyPix).toString()))) {
            this.tostr.warning(`Digite um email válido.`, "Email inválido!");
            this.company.payment.keyPix = "";
          }
        }
    }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }
  verifyDate(date,field){
    if(!(new RegExp(this.datePattern).test(date))){
        this.tostr.warning(`Digite uma data válida.`,"Data inválida!");
        this.company[`${field}`] = "";
    }
  }

  async getS3Files(){
    this.fileList = await this.awsService.getFiles(this.company._id);
  };

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async deleteFile(name){
    await this.awsService.deleteFile(name);
    await this.getS3Files();
  }

  async upload() {
    try {
      let id = this.company._id;
      let length = this.selectedFiles.length;
      for(let i=0; i<length; i++){
        const file = this.selectedFiles.item(i);
        await this.awsService.uploadfile(file,id);
      }

      await this.getS3Files();
    } catch (error) {
      console.log(error);
    }
 }

  async download(name){
    this.downloadUrl = await this.awsService.download(name);
  }

  async generateContract(){
    try{
      this.company.generatedContract = true;
      let response = await this.companiesService.generateContract(this.company);
      if(response.success)
        this.tostr.success("Contrato gerado com sucesso");
      this.router.navigate(['/companies']);
    } catch (error) {
      console.log(error);
    }
  }

  emailBlur() {
    this.tostr.warning('Aperte ENTER para confirmar a inserção do e-mail');
  }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.company.payment.typePix, this.companyForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.company.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.company.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.company.payment.keyPix)){
                    this.tostr.warning('CPF/CNPJ inválido.');
                    this.company.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.company.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.company.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    validateKeyPix(control: AbstractControl){
        if(!control.value)
            return {keyPix:true}
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/companies-edit/companies-edit.component.ts